import React from 'react';

const KPICard = ({ title, value, icon, tooltipText, style, className }) => {
  return (
    <div title={tooltipText} style={style} className={`${className} cursor-move`}>
      {/* <div className="bg-white p-5 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 flex items-center space-x-4 h-full"> */}
      <div className="bg-white p-10 rounded-xl shadow-sm hover:shadow-lg transition-shadow duration-300 flex items-center space-x-4 h-full">
        <div className="bg-slate-100 p-3 rounded-full">
          {icon}
        </div>
        <div>
          <p className="text-sm text-slate-500 font-medium">{title}</p>
          <p className="text-2xl font-bold text-slate-800">{value}</p>
        </div>
      </div>
    </div>
  );
};

export default KPICard;